module.exports = __webpack_public_path__ + "static/media/03-2-galeria-02-tory-burch-mobile@2x.549c6756.jpg";